import React, { ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.h2`
  color: #ffffff;
  font-family: 'Manrope', sans-serif !important;
  font-size: clamp(42px, 5vw, 42px);
  font-weight: 500;
  margin: 0 0 min(4vh, 30px);
  text-align: center;
  line-height: 80%;
  width: 100%;
`;

interface TitleProps {
  children: ReactNode;
}

export const Title: React.FC<TitleProps> = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};
